<template>
	<a
		:href="linkUrl"
		:class="linkClass"
		:title="linkTitle"
		v-text="linkText"
		@click="ctaClick"
	/>
</template>

<script>
export default {
	name: 'Promotions',
	props: {
		banner: Object,
		affiliate: String,
		location: String,
		name: String,
		creativeSlot: String,
		linkUrl: String,
		linkClass: String,
		linkText: String,
		linkTitle: String
	},
	data () {
		return {
			product: null,
			promotionEvent: null
		}
	},
	methods: {
		ctaClick () {
			const clickedEvent = JSON.parse(JSON.stringify(this.promotionEvent))
			clickedEvent.event_params.gtm_name = 'EEC_select_promotion'

			window.dataLayer.push({'event_params': null, 'ecommerce': null})
			window.dataLayer.push(clickedEvent)
		}
	},
	mounted() {
		if (this.banner) {
			let creativeName = undefined
			if (this.banner.picture) {
				const picture = this.banner.picture.split("/")
				creativeName = picture[picture.length - 1]
			}
			this.product = this.banner.product

			const category = this.product.category.parent_category ? this.product.category.parent_category.title : this.product.category.title
			const subcategory = !this.product.category.parent_category ? undefined : this.product.category.title
			const productPrice = this.product.locale_price.price || this.product.price
			this.promotionEvent = {
				'event': 'RO_event_EEC',
				'event_params': {
					'gtm_name': 'EEC_view_promotion'
				},
				'ecommerce': {
					'currency': global.current_currency,
					'location_id': this.location,
					'promotion_name': this.name,
					'promotion_id': this.banner.id,
					'creative_name': creativeName,
					'creative_slot': this.creativeSlot,
					'items': [{
						'item_id': this.product.id,
						'item_name': this.product.title,
						'item_variant': undefined,
						'item_brand': 'Lupit Pole',
						'item_category': category ? category : undefined,
						'item_category2': subcategory ? subcategory : undefined,
						'price': this.product.price_discount > 0 ? (productPrice - productPrice * (parseFloat(this.product.price_discount) / 100)) : productPrice,
						'discount': productPrice * (parseFloat(this.product.price_discount) / 100),
						'affiliation': this.affiliate ? this.affiliate : undefined
					}]
				}
			}

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({'event_params': null, 'ecommerce': null})
			window.dataLayer.push(JSON.parse(JSON.stringify(this.promotionEvent)))
		}
	}
}
</script>
